import { useInitData } from '../../../hooks'
import { getRequestProfilePathname } from '../../../utils/link'
import { BirdviewAttentionRow } from '../BirdviewAttentionRow'
import { BirdviewCard } from '../BirdviewCard'
import { BIRDVIEW_SECTION_TARGET } from '../DashboardBirdview.constants.targets'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'
import { getBirdviewRowRequestActions } from '../DashboardBirdview.utils.rows'

import {
  checkHasBirdviewAttentionMore,
  getBirdviewAttentionRequestId,
} from './BirdviewAttentionWidget.utils'
import { BirdviewAttentionWidgetSkeleton } from './BirdviewAttentionWidgetSkeleton'

function BirdviewAttentionWidget({
  activityDoneById,
  dragHandleProps,
  pendingIds,
  requestActions,
  section,
  title,
  onActivityToggle,
  onNavigate,
}) {
  const { getListTarget } = useBirdviewListTarget()

  const { availableSections } = useInitData()

  const rowRequestActions = getBirdviewRowRequestActions({
    requestActions,
    onReload: section.reload,
  })

  function handleOpenItem({ event, item }) {
    onNavigate({
      event,
      link: getRequestProfilePathname({
        availableSections,
        id: getBirdviewAttentionRequestId(item),
      }),
    })
  }

  function handleShowAll(event) {
    onNavigate({
      event,
      link: getListTarget(BIRDVIEW_SECTION_TARGET.attention),
    })
  }

  return (
    <BirdviewCard
      Skeleton={BirdviewAttentionWidgetSkeleton}
      count={section.total}
      dragHandleProps={dragHandleProps}
      hasMore={checkHasBirdviewAttentionMore(section.items)}
      isRefreshing={section.isRefreshing}
      state={section.state}
      title={title}
      onRetry={section.reload}
      onShowAll={handleShowAll}
    >
      {section.items.map(item => (
        <BirdviewAttentionRow
          activityDoneById={activityDoneById}
          extra={section.extra}
          item={item}
          key={item.id}
          pendingIds={pendingIds}
          requestActions={rowRequestActions}
          onActivityToggle={onActivityToggle}
          onOpenItem={handleOpenItem}
        />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewAttentionWidget
